module.exports = __webpack_public_path__ + "img/Z60Q_12.d77973cc.jpg";